import { useIntl } from 'react-intl';

import { ReactComponent as CalendarIcon } from 'assets/bosta-icons/calendar-1.svg';

import './EmptyMonth.less';

const EmptyMonth = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="br-merchant-empty-month">
      <span className="br-merchant-empty-month__icon">
        <CalendarIcon />
      </span>
      <div className="br-merchant-empty-month__details">
        <span className="heading1">
          {formatMessage({
            id: 'merchant_analysis.empty_month.select_month_title'
          })}
        </span>
        <span className="body">
          {formatMessage({
            id: 'merchant_analysis.empty_month.select_month_subtitle'
          })}
        </span>
      </div>
    </div>
  );
};

export default EmptyMonth;
